class PartEvent extends Event {
  part: any = undefined;
}

export default PartEvent;
